import { useState } from "react";

const ApplicationSettings = () => {
    return (
        <div className="my-3">
            Application Settings
        </div>
    )
}

export default ApplicationSettings